import http from "../../utils/http"

/**
 * 獲取商品分類樹結構
 */
export function tree(params) {
    return http({
        url: "/api/goodscategory/tree",
        data: params
    })
}

/**
 * 獲取商品品牌信息
 * @param {Object} params 參數
 */
export function relevanceinfo(params) {
    return http({
        url: "/api/goodscategory/relevanceinfo",
        data: params
    })
}

/**
 * 獲取商品分類信息
 * @param {Object} params 參數 category_id:1
 */
export function goodsCategoryInfo(params) {
    return http({
        url: "/api/goodscategory/info",
        data: params
    })
}
